export const ORDER_STATUS = {
  PENDING: 0,
  OPEN: 1,
  HOLD: 2,
  COMPLETED: 3,
  CANCELLED: 4,
  REFUNDED: 5
};

